import React from "react";
import { Route } from "react-router-dom";
import { Helmet } from "react-helmet";

import "./assets/css";
import {appConf} from "../Setup/appConfig/app.config";

/** Containers */
import PartnerAgreementFormContainer from "./Container/AgreementContainer";
import CommitmentContainer from "./Container/CommitmentContainer";

/** Protect Route Component */
import ProtectedRouteHOC from "../NTICore/component/HOC/ProtectedRouteHOC";

/** Router configuration */
const User = ProtectedRouteHOC(["public"]);
const SuccessFormUser = ProtectedRouteHOC(["public"]);

export const agreementRoute = {
  form: "/",
  success_form: "/success_agreement",
  commitment: "/commitment",
};

export const PartnerAgreementRoutes = () => {
  return (
    <React.Fragment>
      {/*Start of HubSpot Embed Code only for production mode */}
      <Helmet>
        {
          appConf.isDevelopmentMode &&
          <script type="text/javascript" id="hs-script-loader" async defer src="//js.hs-scripts.com/8693616.js"/>
        }
        {/*End of HubSpot Embed Code only for production mode*/}
      </Helmet>
      <Route
        exact
        path={agreementRoute.form}
        component={User(PartnerAgreementFormContainer)}
      />
      <Route
        exact
        path={agreementRoute.commitment}
        component={SuccessFormUser(CommitmentContainer)}
      />
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/modules/PartnerAgreement/route.js